var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptySearch = function SvgEmptySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 79,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "48.086%",
    x2: "51.999%",
    y2: "50.524%",
    id: "EmptySearch_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "46.08%",
    x2: "51.999%",
    y2: "51.073%",
    id: "EmptySearch_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "49.918%",
    x2: "51.999%",
    y2: "50.022%",
    id: "EmptySearch_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "31.539%",
    x2: "51.999%",
    y2: "55.056%",
    id: "EmptySearch_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.999%",
    y1: "0%",
    x2: "51.999%",
    y2: "63.692%",
    id: "EmptySearch_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: 0.052,
    fill: "#000",
    opacity: 0.59,
    cx: 41.325,
    cy: 76.667,
    rx: 17.325,
    ry: 1.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.126 7.127H9.74a4.562 4.562 0 0 0-4.562 4.562v9.123h69.947V7.127Z",
    fill: "url(#EmptySearch_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.126 4.562A4.562 4.562 0 0 0 70.564 0H46.723a6.082 6.082 0 0 0-5.281 3.064l-4.33 7.58h38.014V4.562Z",
    fill: "url(#EmptySearch_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySearch_svg__c)",
    d: "M5.18 11.401h69.946v2.833H5.179z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.247 20.18a6.085 6.085 0 0 0-6.025-6.92H6.082a6.082 6.082 0 0 0-6.024 6.92l5.914 42.576A6.082 6.082 0 0 0 11.996 68h56.313a6.082 6.082 0 0 0 6.024-5.244l5.914-42.576Z",
    fill: "#CADCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.569 23.86a6.087 6.087 0 0 1 6.058-5.542h67.051a6.08 6.08 0 0 1 6.058 5.541l.51-3.68a6.085 6.085 0 0 0-6.024-6.92H6.082a6.082 6.082 0 0 0-6.024 6.92l.51 3.68Z",
    fill: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.311 52.834a3.041 3.041 0 0 0-3.04-3.041H18.105a3.041 3.041 0 0 0-3.041 3.04v3.042a3.041 3.041 0 0 0 3.04 3.041H30.27a3.041 3.041 0 0 0 3.041-3.041v-3.041Zm22.807-28.566c-8.811 0-15.966 7.155-15.966 15.966 0 8.812 7.155 15.966 15.966 15.966 8.812 0 15.966-7.154 15.966-15.966 0-8.811-7.154-15.966-15.966-15.966Zm0 4.562c6.294 0 11.405 5.11 11.405 11.404S62.413 51.64 56.118 51.64c-6.297-.004-11.4-5.108-11.404-11.405 0-6.293 5.11-11.404 11.404-11.404Z",
    fill: "url(#EmptySearch_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.434 51.26 14.184 14.184a2.281 2.281 0 1 0 3.227-3.225L67.661 48.035a2.282 2.282 0 0 0-3.227 3.225Z",
    fill: "url(#EmptySearch_svg__e)"
  }))));
};
export default SvgEmptySearch;